import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Column from "@amzn/meridian/column";
import LandingHeader from "src/components/pages/landing/header";
import LandingHome from "src/components/pages/landing/home";
import LandingFooter, { NavTab } from "src/components/pages/landing/footer";
import HistoryView from "src/components/pages/landing/historyView";
import { getAustinEnabledDefault } from "src/config/stage";
import "./landing.scss";

const AUSTIN_ENABLED_PARAM = "austin_enabled";

const LandingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<NavTab>(NavTab.HOME);
  const [searchParams, setSearchParams] = useSearchParams();

  // Derive the value with a per-stage fallback so the correct experience is
  // rendered on the very first render, before the URL is synced. An explicit
  // value in the URL always wins, so users can override the default.
  const austinEnabled =
    (searchParams.get(AUSTIN_ENABLED_PARAM) ?? String(getAustinEnabledDefault())) === "true";

  // Sync the default into the URL on mount when the param is not present, so
  // the address bar reflects the active experience and is shareable.
  useEffect(() => {
    if (searchParams.get(AUSTIN_ENABLED_PARAM) === null) {
      const next = new URLSearchParams(searchParams);
      next.set(AUSTIN_ENABLED_PARAM, String(getAustinEnabledDefault()));
      setSearchParams(next, { replace: true });
    }
  }, []);

  return (
    <div className="app-gradient-bg pwa-scrollable">
      <Column className="home-content" spacingInset="none none 600">
        <LandingHeader />
        {activeTab === NavTab.HOME && <LandingHome austinEnabled={austinEnabled} />}
        {activeTab === NavTab.HISTORY && <HistoryView />}
      </Column>
      <LandingFooter active={activeTab} onTabChange={setActiveTab} />
    </div>
  );
};

export default LandingPage;
